export default __webpack_public_path__ + "static/media/soesvinget-property-04.5901d0ef.jpg";